import expenses from './expenses';
import expenseCategories from './expenseCategories';
import fraud from './fraud';

export default {
  expenses,
  expenseCategories,
  fraud,
};
